const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL";
const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCTS_REQUEST";
const SINGLE_PRODUCT_SUCCESS = "SINGLE_PRODUCTS_SUCCESS";
const SINGLE_PRODUCT_FAIL = "SINGLE_PRODUCTS_FAIL";
const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";
const ADD_TO_CART = "ADD_TO_CART";
const INCREASE = "INCREASE";
const DECREASE = "DECREASE";
const DELETE = "DELETE";
const CLEAR_CART = "CLEAR_CART";
const CHECK_OUT = "CHECK_OUT";

export {
    GET_PRODUCTS_REQUEST,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    SINGLE_PRODUCT_REQUEST,
    SINGLE_PRODUCT_SUCCESS,
    SINGLE_PRODUCT_FAIL,
    GET_CATEGORIES_REQUEST,
    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_FAIL,
    ADD_TO_CART,
    INCREASE,
    DECREASE,
    DELETE,
    CLEAR_CART,
    CHECK_OUT,
}